import useAuthCheck from 'hooks/useAuthCheck';
import { Navigate, useLocation, useMatch } from 'react-router-dom';

export default function PublicRoute({ children }) {
  const match = useMatch('/auth/*');
  const { authChecked } = useAuthCheck();
  const location = useLocation();

  if (match && authChecked) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}
